import { withConfig } from "@/utils/withConfig";
import { CardSelector } from "./CardSelector";
import type { CardSelectorProps } from "./CardSelectorProps";

export * from "./CardSelector";
export * from "./CardSelectorProps";

export const CardSelectorWithConfig = withConfig<CardSelectorProps>(
  CardSelector,
  "card_selector",
);
